import HOOK from "../components/hooks"
import { COLOR, COMPANY_REG_TYPE, EXEC_ENUM, FTSE_INDEX, JARGON, INDP_ENUM, NEWS_CATEGORY, POSITION, POSITION_ENUM, SEX, SEX_ENUM, TENSE, TENSE_ENUM, EXEC, INDP } from "./constants"

const resetBit = 1
const countrySuffix = "incorporated"
const industrySuffix = "companies"
const connectionsSuffix = `${JARGON.CONNECTIONS.toLowerCase()}`
const indexSuffix = "index constituents"
const sexSuffix = "gender"
const tenseSuffix = `${JARGON.CONNECTIONS.toLowerCase()}`
const unchecked = true // use this in nextBit() to set the default to unchecked

let bit = 0.5
let count = 0 // Incremented for each checkbox and to be used as key - instead of 'bit' because the bits will  be starting at 0 fro each group

/**
 * @param {Object} dummy
 */
const nextBit = ({ match, name, positionEnum, resetBit, sexEnum, suffix, tenseEnum, tooltipTitle, unchecked, execEnum, indpEnum }) => {
  bit = resetBit || (bit *= 2)
  return {
    BIT: bit,
    COLOR: tenseEnum !== undefined
      ? TENSE[tenseEnum].COLOR
      : sexEnum !== undefined
        ? SEX[sexEnum].COLOR
        : COLOR.MID_GREY,
    COUNT: count++,
    LABEL_COLOR: positionEnum !== undefined
      ? POSITION[positionEnum].COLOR // "black" except for secretary which is dark_grey
      : tenseEnum !== undefined
        ? TENSE[tenseEnum].COLOR
        : sexEnum !== undefined
          ? SEX[sexEnum].COLOR
          : COLOR.BLACK,
    MATCH: match || name,
    NAME: positionEnum !== undefined
      ? POSITION[positionEnum].NAME
      : tenseEnum !== undefined
        ? TENSE[tenseEnum].NAME
        : sexEnum !== undefined
          ? SEX[sexEnum].NAME
          : execEnum !== undefined
            ? EXEC[execEnum].NAME
            : indpEnum !== undefined
              ? INDP[indpEnum].NAME
              : name,
    SUFFIX: suffix || "",
    TOOLTIP_TITLE: tooltipTitle,
    UNCHECKED: unchecked,
  }
}

export const CHECKBOX_LEVEL = {
  STANDARD: 0,
  PREMIUM: 1,
}

const initCheckboxGroup = level => ({
  LEVEL: level,
  enabled: false,
  expanded: false,
})

export const CHECKBOX_GROUP_PROPS = {
  //#region CHECKBOX_LEVEL.STANDARD
  [HOOK.CONNECTIONS]: initCheckboxGroup(CHECKBOX_LEVEL.STANDARD),
  [HOOK.TENSE]: initCheckboxGroup(CHECKBOX_LEVEL.STANDARD),
  [HOOK.OFFICER_SEARCH]: initCheckboxGroup(CHECKBOX_LEVEL.STANDARD),
  [HOOK.COMPANY_SEARCH]: initCheckboxGroup(CHECKBOX_LEVEL.STANDARD),
  [HOOK.COMPANY_REG_TYPE]: initCheckboxGroup(CHECKBOX_LEVEL.STANDARD),
  //#endregion CHECKBOX_LEVEL.STANDARD

  //#region CHECKBOX_LEVEL.PREMIUM
  [HOOK.LSE_INDEX]: initCheckboxGroup(CHECKBOX_LEVEL.PREMIUM),
  [HOOK.FAVOURITE]: initCheckboxGroup(CHECKBOX_LEVEL.PREMIUM),
  [HOOK.OTHER_INDEX]: initCheckboxGroup(CHECKBOX_LEVEL.PREMIUM),
  [HOOK.INDUSTRY]: initCheckboxGroup(CHECKBOX_LEVEL.PREMIUM),
  [HOOK.SEX]: initCheckboxGroup(CHECKBOX_LEVEL.PREMIUM),
  [HOOK.POSITION]: initCheckboxGroup(CHECKBOX_LEVEL.PREMIUM),
  [HOOK.COUNTRY]: initCheckboxGroup(CHECKBOX_LEVEL.PREMIUM),
  [HOOK.NEWS_CATEGORY]: initCheckboxGroup(CHECKBOX_LEVEL.PREMIUM),
  [HOOK.COMPANY_TYPE]: initCheckboxGroup(CHECKBOX_LEVEL.PREMIUM),
  [HOOK.COMMITTEE]: initCheckboxGroup(CHECKBOX_LEVEL.PREMIUM),
  [HOOK.EXEC]: initCheckboxGroup(CHECKBOX_LEVEL.PREMIUM), // executive
  [HOOK.INDP]: initCheckboxGroup(CHECKBOX_LEVEL.PREMIUM), // independent
  [HOOK.DELISTED]: initCheckboxGroup(CHECKBOX_LEVEL.PREMIUM),
  //#endregion CHECKBOX_LEVEL.PREMIUM
}

export const CHECKBOX = {
  DEFAULTS: null,
  [HOOK.COMPANY_TYPE]: [
    nextBit({ name: `${JARGON.COMPANY_TYPE.TRADE} Company`, resetBit }),
    nextBit({ name: `${JARGON.COMPANY_TYPE.INVEST} Company`, tooltipTitle: `in AIC (${JARGON.AIC}) investment company universe` }),
  ],
  [HOOK.CONNECTIONS]: [
    nextBit({ name: JARGON.CONNECTIONS, suffix: connectionsSuffix, resetBit, unchecked }), // 0
  ],
  [HOOK.COUNTRY]: [
    nextBit({ name: "UK", suffix: countrySuffix, resetBit }),
    nextBit({ name: "foreign", suffix: countrySuffix }),
  ],
  [HOOK.FAVOURITE]: [
    nextBit({ name: "Fav. LSE Companies", resetBit, tooltipTitle: `Favourite LSE Companies` }),
  ],
  [HOOK.INDUSTRY]: [
    nextBit({ name: "Basic Materials", suffix: industrySuffix, resetBit }),
    nextBit({ name: "Consumer Discretion.", suffix: industrySuffix, match: "Consumer Discretionary" }),
    nextBit({ name: "Consumer Staples", suffix: industrySuffix }),
    nextBit({ name: "Energy", suffix: industrySuffix }),
    nextBit({ name: "Financials", suffix: industrySuffix }),
    nextBit({ name: "Health Care", suffix: industrySuffix }),
    nextBit({ name: "Industrials", suffix: industrySuffix }),
    nextBit({ name: "Real Estate", suffix: industrySuffix }),
    nextBit({ name: "Technology", suffix: industrySuffix }),
    nextBit({ name: "Telecoms", suffix: industrySuffix, match: "Telecommunications" }),
    nextBit({ name: "Utilities", suffix: industrySuffix }),
    nextBit({ name: JARGON.OTHER, suffix: industrySuffix }),
  ],
  [HOOK.LSE_INDEX]: [
    nextBit({ name: FTSE_INDEX[1], suffix: indexSuffix, resetBit }), // "FTSE 100"
    nextBit({ name: FTSE_INDEX[2], suffix: indexSuffix }), // "FTSE 250"
    nextBit({ name: FTSE_INDEX[4], suffix: indexSuffix }), // "FTSE SmallCap"
    nextBit({ name: FTSE_INDEX[8], suffix: indexSuffix }), // "AIM All-Share"
    nextBit({ name: FTSE_INDEX[16], suffix: indexSuffix }), // "Other LSE"
  ],
  [HOOK.NEWS_CATEGORY]: [
  ],
  [HOOK.POSITION]: [
    nextBit({ positionEnum: POSITION_ENUM.CEO, resetBit }),
    nextBit({ positionEnum: POSITION_ENUM.CFO }),
    nextBit({ positionEnum: POSITION_ENUM.OTHER_EXEC_DIRECTOR }),
    nextBit({ positionEnum: POSITION_ENUM.CHAIRMAN }),
    nextBit({ positionEnum: POSITION_ENUM.SENIOR_NON_EXEC }),
    nextBit({ positionEnum: POSITION_ENUM.NON_EXEC_DIRECTOR }),
    nextBit({ positionEnum: POSITION_ENUM.OTHER }),
    nextBit({ positionEnum: POSITION_ENUM.SECRETARY, unchecked }),
    nextBit({ positionEnum: POSITION_ENUM.PSC, unchecked }),
  ],
  [HOOK.SEX]: [
    nextBit({ sexEnum: SEX_ENUM.MALE, suffix: sexSuffix, resetBit }), // 0
    nextBit({ sexEnum: SEX_ENUM.FEMALE, suffix: sexSuffix }), // 1
    nextBit({ sexEnum: SEX_ENUM.UNKNOWN, suffix: sexSuffix }), // 2
  ],
  [HOOK.EXEC]: [
    nextBit({ execEnum: EXEC_ENUM.EXEC, resetBit }), // 0
    nextBit({ execEnum: EXEC_ENUM.NON_EXEC }), // 1
    nextBit({ execEnum: EXEC_ENUM.UNKNOWN }), // 2
  ],
  [HOOK.INDP]: [
    nextBit({ indpEnum: INDP_ENUM.INDP, resetBit }), // 0
    nextBit({ indpEnum: INDP_ENUM.NON_INDP }), // 1
    nextBit({ indpEnum: INDP_ENUM.UNKNOWN }), // 2
  ],
  [HOOK.TENSE]: [
    nextBit({ tenseEnum: TENSE_ENUM.CURRENT, suffix: tenseSuffix, resetBit }), // 0
    nextBit({ tenseEnum: TENSE_ENUM.NOTICE, suffix: tenseSuffix }), // 1
    nextBit({ tenseEnum: TENSE_ENUM.PAST, suffix: tenseSuffix, unchecked }), // 2
    nextBit({ tenseEnum: TENSE_ENUM.FUTURE, suffix: tenseSuffix, unchecked }), // 3
  ],
  [HOOK.OFFICER_SEARCH]: [
    nextBit({ name: "Corporate officers", unchecked, resetBit, tooltipTitle: "Search for corporate officers, as well as people" }),
    nextBit({ name: "Include zero roles", unchecked, tooltipTitle: "Include officers that have/had no appointments in currently active companies" }),
    // nextBit({ name: "Include secretaries", unchecked }),
  ],
  [HOOK.COMPANY_SEARCH]: [
    nextBit({ name: "Active", resetBit }),
    nextBit({ name: "Dissolved", unchecked }),
    nextBit({ name: "Other", unchecked }),
  ],
  [HOOK.COMPANY_REG_TYPE]: [
    nextBit({ name: COMPANY_REG_TYPE.LTD, resetBit }),
    nextBit({ name: COMPANY_REG_TYPE.PLC }),
    nextBit({ name: COMPANY_REG_TYPE.OTHER, unchecked }),
  ],
  [HOOK.COMMITTEE]: [
    nextBit({ name: "Audit Chair", resetBit }),
    nextBit({ name: "Audit Member" }),
    nextBit({ name: "Remuneration Chair" }),
    nextBit({ name: "Remuneration Member" }),
    nextBit({ name: "Nomination Chair" }),
    nextBit({ name: "Nomination Member" }),
    nextBit({ name: "Non-Members", unchecked }),
  ],
  [HOOK.EVENT]: [
    nextBit({ name: "Unknown", resetBit }),
    nextBit({ name: "CoGpChange" }),
    nextBit({ name: "CoNameChange" }),
    nextBit({ name: "BoardRoleChange" }),
    nextBit({ name: "CommitteeChange" }),
    nextBit({ name: "CoTickerChange" }),
    nextBit({ name: "Audit Member" }),
  ],
  [HOOK.DELISTED]: [
    nextBit({ name: "Delisted", tooltipTitle: `Companies that are no longer in one in the main indexes (NB checkbox only affects Changes to Index Consitituents card)`, resetBit }),
  ],
}

// Add news categories from CONTANTS.NSM_CATEGORY
let first = true
for (const key in NEWS_CATEGORY) {
  if (typeof NEWS_CATEGORY[key] !== "function")
    CHECKBOX[HOOK.NEWS_CATEGORY].push(nextBit({ name: NEWS_CATEGORY[key], resetBit: first ? resetBit : null }))
  first = false
}

// Create OTHER_INDEX, instead of push CHECKBOX[HOOK.LSE_INDEX] because having the latter
// would mess up role counts. NB: OTHER_INDEX is only shown in Person menu
CHECKBOX[HOOK.OTHER_INDEX] = [nextBit({ name: "Other (inc. private)", suffix: indexSuffix, resetBit })]

const getDefault = checkbox => {
  var totals = {}
  for (const property in checkbox)
    // Only the hook-keyed arrays (eg CHECKBOX[HOOK.LSE_INDEX]) contribute a default - skip
    // non-array properties such as CHECKBOX.DEFAULTS itself, so this stays safe to call again
    // (eg from resetCheckboxDefaults()) after CHECKBOX.DEFAULTS has already been set once
    if (Array.isArray(checkbox[property])) {
      totals[property] = 0
      const checked = checkbox[property].filter(item => !!!item.UNCHECKED)
      checked.forEach(element => totals[property] += element.BIT)
    }

  return totals
}

CHECKBOX.DEFAULTS = getDefault(CHECKBOX)

Object.freeze(CHECKBOX)

// CHECKBOX.DEFAULTS is a shared, mutable singleton: watchGetCheckboxes() merges a logged-in
// user's saved checkboxes into it (Object.assign), and it's never otherwise reset. Without this,
// switching users within the same tab (login, or the dev-only "Switch User") would leak the
// previous user's checkbox selections - including any trial-level restrictions - into the next
// user's session until/unless every hook happens to be overwritten by their own saved checkboxes.
// Call this on every fresh login, but NOT on a silent token refresh of the same session.
export const resetCheckboxDefaults = () => Object.assign(CHECKBOX.DEFAULTS, getDefault(CHECKBOX))

// Gets the BIT value for the object in the array with matching name
// eg for (CHECKBOXES[HOOK.LSE_INDEX], "AIM All-Share") returns 8
export function getBitByName(objectArray, name) {
  const found = objectArray.find(item => item.NAME === name)
  return found ? found.BIT : null; // return null if not found
}

// Gets the NAME value for the object in the array with matching BIT
// eg for (CHECKBOXES[HOOK.LSE_INDEX], 8) returns "AIM All-Share"
export function getNameByBit(objectArray, bit) {
  const found = objectArray.find(item => item.BIT === bit)
  return found ? found.NAME : null; // return null if not found
}